import { render, staticRenderFns } from "./UpdateOrdensTrabalho.vue?vue&type=template&id=bb97987a&scoped=true"
import script from "./UpdateOrdensTrabalho.vue?vue&type=script&lang=js"
export * from "./UpdateOrdensTrabalho.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrdensTrabalho.vue?vue&type=style&index=0&id=bb97987a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb97987a",
  null
  
)

export default component.exports